import React, { useState, useMemo, useEffect } from 'react';
import Beams from './components/Beams';
// import './components/Beams.css'; 
import './App.css';

const translations = {
  nl: {
    nav: { about: 'Profiel', specialty: 'Specialiteit', appointments: 'Afspraken', reachability: 'Bereikbaarheid' },
    hero: { title: 'Dr Emmanuel Thienpont', subtitle: 'Orthopedisch chirurg, knie specialist', cta: 'Maak een afspraak' },
    about: {
      title: 'Profiel',
      experienceTitle: 'Professionele Ervaring',
      experienceText:
        'Dr Thienpont studeerde af in 2001 als orthopedisch chirurg na een opleiding aan de KU Leuven, waarna hij nog een extra bekwaming volgde in de kniechirurgie in de Verenigde Staten. Hij was diensthoofd orthopedie in Saint Luc tot 2024, alsook gewoon hoogleraar aan de UCL. Hij heeft een Master in Business Administration (Executive MBA) van de UCL en een PhD van het UGent. Dr Thienpont is stichtend-lid en permanent executive board member van de European Knee Society.',
      accreditationTitle: 'Accreditatie – Conventie',
      accreditationText: 'Geaccrediteerd en partieel geconventioneerd',
      languagesTitle: 'Talen',
      langList: ['Nederlands', 'Frans', 'Engels'],
    },
    specialty: {
      title: 'Specialiteit',
      b1Title: 'Acute en Chronische Knieletsels',
      b1Text:
        'Eerste opvang en advies met betrekking tot acute en chronische knieletsels. <br/>De initieel ingestelde behandeling na een plots optredend knieprobleem kan bepalend zijn voor de verder te volgen behandelingsstrategie. <br/> De preventie en de niet operatieve behandeling van knie arthrose blijft heden ten dage een interessante uitdaging die expertise en ervaring vraagt waarbij kosten, efficiëntie en wetenschappelijke onderbouw <br/> van belang zijn.',
      b2Title: 'Kruisband en Meniscusletsels',
      b2Text:
        'Sportletsels en ongevallen van het dagelijks leven kunnen leiden tot kruisband of meniscale letsels. Na een correcte conservatieve behandeling is soms arthroscopisch herstel voor blijvende letsels aangewezen.',
      b3Title: 'Prothese Chirurgie',
      b3Text:
        'Arthrose die te invaliderend geworden is, vraagt uiteindelijk om een chirurgische behandeling. Dr Thienpont heeft 20 jaar ervaring met het partieel vervangen van kniëen (alle types van partiële prothesen), met totale knieprothesen en met het reviseren van knieprothesen die niet het verwachte resultaat opleverden.',
    },
    appointments: {
      title: 'Afspraken',
      primary: ['Consultaties zijn alleen op afspraak'],
      secondary: [
        'Maak een telefonische afspraak: 02 311 55 30',
        'Indien u uw afspraak niet kan nakomen, gelieve deze minstens 24 uur op voorhand te annuleren via het bovenstaande telefoonnummer',
        'Voor urgente medische problemen, contacteer de spoedafdeling van ons ziekenhuis',
      ],
      paymentTitle: 'Betaling',
      paymentList: ['Betaling via banking app and QR-code', 'Cash betaling is ook mogelijk', 'Geen terminal voor kaart betalingen'],
    },
    reachability: { title: 'Bereikbaarheid', address: 'Adres: Dr. V. De Walsplein 36, 3070 Kortenberg' },
    backToTop: 'Naar boven',
  },

  en: {
    nav: { about: 'About', specialty: 'Specialty', appointments: 'Appointments', reachability: 'Reachability' },
    hero: { title: 'Dr Emmanuel Thienpont', subtitle: 'Orthopaedic surgeon, knee specialist', cta: 'Book an appointment' },
    about: {
      title: 'About',
      experienceTitle: 'Professional Experience',
      experienceText:
        'Dr Thienpont graduated in 2001 as an orthopaedic surgeon at KU Leuven and completed additional training in knee surgery in the United States. He headed the Orthopaedics Department at Saint Luc until 2024 and served as a full professor at UCL. He holds an Executive MBA from UCL and a PhD from Ghent University. Dr Thienpont is a founding member and permanent executive board member of the European Knee Society.',
      accreditationTitle: 'Accreditation – Convention',
      accreditationText: 'Accredited and partially conventioned',
      languagesTitle: 'Languages',
      langList: ['Dutch', 'French', 'English'],
    },
    specialty: {
      title: 'Specialty',
      b1Title: 'Acute and Chronic Knee Injuries',
      b1Text:
        'First-line assessment and advice for acute and chronic knee injuries. <br/>The initial treatment after a sudden knee problem can determine the subsequent treatment strategy. Preventing osteoarthritis and non-operative management remain important challenges that require expertise and experience with attention to costs, efficiency and scientific evidence.',
      b2Title: 'ACL and Meniscal Injuries',
      b2Text:
        'Sports injuries and daily accidents can lead to cruciate ligament or meniscal tears. After appropriate conservative care, arthroscopic repair may be indicated for persistent lesions.',
      b3Title: 'Prosthetic Surgery',
      b3Text:
        'When osteoarthritis becomes too disabling, surgery may be required. Dr Thienpont has 20 years of experience with partial knee replacements (all types), total knee arthroplasty, and revisions of knee prostheses that did not deliver the expected result.',
    },
    appointments: {
      title: 'Appointments',
      primary: ['Consultations are by appointment only'],
      secondary: [
        'Make an appointment: 02 311 55 30',
        'If you cannot attend, please cancel at least 24 hours in advance using the phone number above',
        'For urgent medical issues, contact the emergency department of our hospital',
      ],
      paymentTitle: 'Payment',
      paymentList: ['Pay via banking app and QR code', 'Cash payments are also possible', 'No card terminal available'],
    },
    reachability: { title: 'Reachability', address: 'Address: Dr. V. De Walsplein 36, 3070 Kortenberg' },
    backToTop: 'Back to top',
  },

  fr: {
    nav: { about: 'À propos', specialty: 'Spécialité', appointments: 'Rendez-vous', reachability: 'Accessibilité' },
    hero: { title: 'Dr Emmanuel Thienpont', subtitle: 'Chirurgien orthopédiste, spécialiste du genou', cta: 'Prendre rendez-vous' },
    about: {
      title: 'À propos',
      experienceTitle: 'Expérience professionnelle',
      experienceText:
        'Le Dr Thienpont est diplômé en 2001 comme chirurgien orthopédiste à la KU Leuven et a effectué une formation complémentaire en chirurgie du genou aux États-Unis. Il a dirigé le service d’orthopédie à Saint Luc jusqu’en 2024 et a été professeur ordinaire à l’UCL. <br/> Il détient un Executive MBA de l’UCL et un doctorat de l’Université de Gand. <br/> Le Dr Thienpont est membre fondateur et membre permanent du conseil exécutif de la <br/>European Knee Society.',
      accreditationTitle: 'Accréditation – Convention',
      accreditationText: 'Accrédité et partiellement conventionné',
      languagesTitle: 'Langues',
      langList: ['Néerlandais', 'Français', 'Anglais'],
    },
    specialty: {
      title: 'Spécialité',
      b1Title: 'Lésions aiguës et chroniques du genou',
      b1Text:
        'La première prise en charge et conseil pour les lésions aïgues et chroniques du genou. Le traitement initial après un problème du genou peut déterminer la stratégie thérapeutique ultérieure. La prévention de l’arthrose et les traitements non opératoires restent des défis importants nécessitant expertise et expérience, avec une attention aux coûts, à l’efficacité et aux preuves scientifiques.',
      b2Title: 'Lésions du ligament croisé et du ménisque',
      b2Text:
        'Les blessures sportives et les accidents de la vie quotidienne peuvent entraîner des lésions des ligaments croisés ou du ménisque. Après un traitement conservateur adéquat, une réparation arthroscopique peut être indiquée pour les lésions persistantes.',
      b3Title: 'Chirurgie prothétique',
      b3Text:
        'Lorsque l’arthrose devient trop invalidante, une intervention chirurgicale peut être nécessaire. Le Dr Thienpont possède 20 ans d’expérience en prothèses partielles du genou (tous types), prothèse totale et révisions de prothèses du genou.',
    },
    appointments: {
      title: 'Rendez-vous',
      primary: ['Les consultations se font uniquement sur rendez-vous'],
      secondary: [
        'Prenez rendez-vous par téléphone : 02 311 55 30',
        'Si vous ne pouvez pas venir, veuillez annuler au moins 24 heures à l’avance via le numéro ci-dessus',
        'Pour les urgences médicales, contactez le service des urgences de notre hôpital',
      ],
      paymentTitle: 'Paiement',
      paymentList: ['Paiement via application bancaire et QR code', 'Paiement en espèces possible', 'Pas de terminal pour cartes'],
    },
    reachability: { title: 'Accessibilité', address: 'Adresse : Dr. V. De Walsplein 36, 3070 Kortenberg' },
    backToTop: 'Haut de page',
  },
};

function App() {
  const [lang, setLang] = useState('nl');

  useEffect(() => {
    const saved = localStorage.getItem('lang');
    if (saved && translations[saved]) setLang(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  const t = useMemo(() => translations[lang], [lang]);

  const highlightPhone = (text) => {
    const re = /(0?2\s*311\s*55\s*30)/;
    const m = text.match(re);
    if (!m) return text;
    const start = m.index;
    const end = start + m[0].length;
    return (
      <>
        {text.slice(0, start)}
        <span className="phone-number">{text.slice(start, end)}</span>
        {text.slice(end)}
      </>
    );
  };

  return (
    <div className="scroll-container">
      <span id="top"></span>
      
      {/* Hero */}
      <section className="hero-section">
        <header className="app-header">
          {/* Logo Div Restored to ensure spacing works on Desktop */}
          <div className="logo">Dr. Emmanuel Thienpont</div>

          <nav className="nav-links">
            <a href="#about">{t.nav.about}</a>
            <a href="#specialty">{t.nav.specialty}</a>
            <a href="#appointments">{t.nav.appointments}</a>
            <a href="#reachability">{t.nav.reachability}</a>
            
            <div className="lang-dd" aria-label="Language selector">
              <select value={lang} onChange={(e) => setLang(e.target.value)}>
                <option value="nl">NL</option>
                <option value="en">EN</option>
                <option value="fr">FR</option>
              </select>
            </div>
          </nav>
        </header>

        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
          <Beams
            beamWidth={3}
            beamHeight={20}
            beamNumber={12}
            lightColor="#ffffff"
            speed={1}
            noiseIntensity={0.5}
            scale={0.2}
            rotation={30}
          />
        </div>

        <div className="overlay-text">
          <h1>{t.hero.title}</h1>
          <p>{t.hero.subtitle}</p>
          <a href="#appointments" className="cta-button">{t.hero.cta}</a>
        </div>
      </section>

      {/* About */}
      <section id="about" className="metal-section">
        <div className="section-content">
          <h2 className="section-title">{t.about.title}</h2>
          <div className="about-row">
            <div className="about-block">
              <h3>{t.about.experienceTitle}</h3>
              <p dangerouslySetInnerHTML={{ __html: t.about.experienceText }} />
            </div>
            <div className="about-block">
              <h3>{t.about.accreditationTitle}</h3>
              <p>{t.about.accreditationText}</p>
            </div>
            <div className="about-block">
              <h3>{t.about.languagesTitle}</h3>
              <ul>
                {t.about.langList.map((li, i) => <li key={i}>{li}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Specialty */}
      <section id="specialty" className="specialty-section">
        <div className="section-content">
          <h2 className="section-title">{t.specialty.title}</h2>
          <div className="specialty-row">
            <div className="specialty-block">
              <h3>{t.specialty.b1Title}</h3>
              <p dangerouslySetInnerHTML={{ __html: t.specialty.b1Text }} />
            </div>
            <div className="specialty-block">
              <h3>{t.specialty.b2Title}</h3>
              <p>{t.specialty.b2Text}</p>
            </div>
            <div className="specialty-block">
              <h3>{t.specialty.b3Title}</h3>
              <p>{t.specialty.b3Text}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Appointments */}
      <section id="appointments" className="metal-section">
        <div className="section-content appointments-clean">
          <h2 className="section-title">{t.appointments.title}</h2>
          
          <div className="glass-panel">
            <h3 className="subheading">Info</h3>
            <ul className="appointments-list">
              {t.appointments.primary.map((li, i) => <li key={i}>{li}</li>)}
            </ul>
            <ul className="appointments-list">
              {t.appointments.secondary.map((li, i) => <li key={i}>{highlightPhone(li)}</li>)}
            </ul>
          </div>

          <div className="glass-panel">
            <h3 className="subheading">{t.appointments.paymentTitle}</h3>
            <ul className="appointments-list">
              {t.appointments.paymentList.map((li, i) => <li key={i}>{li}</li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Reachability */}
      <section id="reachability" className="reachability-section">
        <div className="section-content">
          <h2 className="section-title">{t.reachability.title}</h2>
          <div className="reachability-layout">
            <div className="glass-panel reachability-pane">
               <ul><li>{t.reachability.address}</li></ul>
            </div>
            
            <div className="reachability-map">
              <iframe 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                loading="lazy" 
                allowFullScreen 
                src="https://maps.google.com/maps?q=Dr.+V.+De+Walsplein+36,+3070+Kortenberg&t=&z=15&ie=UTF8&iwloc=&output=embed">
              </iframe>
            </div>
          </div>
        </div>
      </section>

      <a href="#top" className="scroll-top-button" aria-label={t.backToTop}>↑</a>
    </div>
  );
}

export default App;